import axios from 'axios';

const CHATBOT_API_URL = 'https://dev-n8n.huhoka.com/webhook/centraJobAssist';

export interface ChatbotResponse {
  statusCode: number;
  message: string;
  data: { output: string }[];
}

export const chatbotService = {
  sendMessage: async (message: string): Promise<string> => {
    const response = await axios.post<ChatbotResponse>(CHATBOT_API_URL, {
      chatInput: message,
    });

    const data = response.data;
    if (data?.data?.length > 0 && data.data[0].output) {
      return data.data[0].output;
    }

    return 'Sorry, I could not process your request. Please try again.';
  },
};
